import RichTextFieldSB, {
  RichTextFieldSBProps,
} from '@/components/atoms/richTextField/RichTextFieldSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { QuoteComponent } from '@/components/molecules/quote';
import { StrapiThemes } from '@/components/themeProviderUtils';

import { BlockHeaderContent } from '@/features/utils/BlockHeaderContent';
import { BlockWrapper } from '@/features/utils/BlockWrapper';

export type QuoteComponentProps = {
  text: RichTextFieldSBProps;
  theme?: StrapiThemes;
};

export function QuoteComponentStrapi({
  block,
  ...rest
}: BlockComponentModel<QuoteComponentProps>) {
  const { text, theme } = block;

  return (
    <BlockWrapper {...rest} theme={theme?.themeKey}>
      <div data-tracker-component='quote'>
        <BlockHeaderContent>
          <QuoteComponent>
            <div className='text-subtitle-l text-left'>
              <RichTextFieldSB block={text} />
            </div>
          </QuoteComponent>
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
